/* global app */
/* global event */
/* global user, groups, gui, participations */
app.controller('userCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification','$filter', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification, $filter) {

    $scope.user = user;
    $scope.groups = groups;
    $scope.participations = participations || [];
    $scope.birthDate = $scope.user.Geburtstag
    $scope.user.Notification = Notification.permission == "granted";
    $scope.showPushIntervalDetailsSelector = false;
    $scope.showAdminPushSaveButton = false;
    
    $scope.fields = {
        firstname: {visible: false},
        secondname: {visible: false},
        email: {visible: false},
        Handynummer: {visible: false}
    };
    
    $scope.pushIntervalSelectorChanged  = function(){
        if($scope.pushIntervalSelector == "DAYLI"){
            $scope.showPushIntervalDetailsSelector = true;
        }else{
             $scope.showPushIntervalDetailsSelector = false;
        }
    }
    
    $scope.showPushIntervalDetailsSelectorChanged  = function(){
        if($scope.pushIntervalDetailsSelector != ""){
            $scope.showAdminPushSaveButton = true;
        }else{
            $scope.showAdminPushSaveButton = false;
        }
    }
    
    $scope.notificationStateChanged = function(){
            Notification.requestPermission().then(function(result) {
              if (result === 'denied') {
                console.log('Permission wasn\'t granted. Allow a retry.');
                return;
              }
              if (result === 'default') {
                console.log('The permission request was dismissed.');
                return;
              }
              // Do something with the granted permission.
            });
    }
    
    $scope.views = {
        "general":{visible: true},
        "groups":{visible: false},
        "security":{visible: false},
        "administration": {visible: false},
        "activationState": {visible: false},
        "participations": {visible: false},
        "app": {visible: false}
    }
    
    $scope.open2FaDialog = function(){
        gui.openDialog("add2FaDialog");
        $rootScope.$emit("add2FaDialog");
    }
    
    $scope.closeAllViews = function(){
        for (var viewName in $scope.views) {
            $scope.views[viewName].visible = false;
        }
    }
    
    $scope.openView = function(viewName){
        $scope.closeAllViews();
        $scope.views[viewName].visible = true;
    }
    
    $scope.saveChangedUser = function(){
        
        var b = $scope.birthDate;
        var newB = $filter('acDateFilter')(b);
        if(newB == "Invalid Date"){
            console.warn("Invalid date")
            AtlasNotification.info("Falsches Datumsformat. Bitte verwende: JJJJ-MM-TT");
        }else{
            var data = {
                id: $scope.user.id,
                firstname: $scope.user.Vorname,
                secondname: $scope.user.Nachname,
                phonenumber: $scope.user.Handynummer,
                birthdate: b
            }
            
            NetworkService.callOperation("updateUser", data, function(response) {
                AtlasNotification.info("Daten wurde erfolgreich geändert.");
            })
        }
    }
    
    $scope.updateEmail = function(){
        var urlArray = window.location.href.split("/");
        var userIdOrMe = urlArray[urlArray.length-1];
        
        var data = {
            userId: userIdOrMe,
            newEmail: $scope.user.Email
        }
        
        NetworkService.callOperation("sendEmailUpdateEmail", data, function(response) {
            AtlasNotification.info("E-Mail Adresse wurde erfolgreich geändert. Du erhältst in kürze eine E-Mail mit Bestätigungslin");
        })
    }
    
    
    $scope.updateUserState = function(){
        var data = {
            id: $scope.user.id,
            state: $scope.user.Freigeschalten
        }
        
        NetworkService.callOperation("updateUserState", data, function(response) {
            AtlasNotification.info("Daten wurde erfolgreich geändert.");
        })
        
    }
    
    
    $rootScope.$on("imageCropped", function(e,data){
        NetworkService.callOperation("saveUserImage/"+user.id, data, function(){
            AtlasNotification.info("Bild wurde erfolgreich geändert.");
        })
    })
 
}])
